export interface User {
  ref: string;
  email: string;
  phone?: string;
  phoneCc?: string;
  userType?: UserType;
  name?: string;
  basic: boolean;
  newUser: boolean;
  company: string;
  language: string;
  channels: string[];
  totalShipment: number;
  lastWaybill: string;
  lastWaybillDate: Date;
  totalSpending: number;
  createdAt: Date;
  registerPlatform: string;
  referralCode?: string;
  inchargeSales: string;
}

export enum UserType {
  PERSONAL = 'personal',
  BUSINESS = 'business',
}
